// src/pages/gt3x/Schedule.jsx
import PageHero from "../../components/PageHero.jsx";

const GOOGLE_ICAL_FEED_URL =
    "https://calendar.google.com/calendar/ical/race%40racevision.info/public/basic.ics";

const GOOGLE_CALENDAR_SUBSCRIBE_LINK =
    "https://calendar.google.com/calendar/u/0/r?cid=" +
    encodeURIComponent(GOOGLE_ICAL_FEED_URL);

export default function Schedule() {
    return (
        <div className="rv-page">
            <PageHero
                kicker="GT3 Xperience"
                title="Schedule"
                actions={
                    <>
                        <a
                            href={GOOGLE_CALENDAR_SUBSCRIBE_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="button button--primary"
                            style={{ textDecoration: "none" }}
                        >
                            + Google Calendar
                        </a>

                        <a
                            href={GOOGLE_ICAL_FEED_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="button button--secondary"
                            style={{ textDecoration: "none" }}
                        >
                            + iCal abonnieren
                        </a>
                    </>
                }
            >
                Der offizielle Race Schedule der RaceVision GT3 Xperience.
            </PageHero>

            <section className="rv-modern-card rv-modern-card--accent">
                <div className="rv-section-head">
                    <div>
                        <div className="rv-section-kicker">Calendar Sync</div>
                        <h2>Alle Termine in deinen Kalender übernehmen</h2>
                    </div>

                    <span className="rv-status-pill rv-status-pill--info">
                        Automatische Updates
                    </span>
                </div>

                <p className="rv-modern-muted">
                    Du kannst die komplette GT3X Season als Kalender abonnieren.
                    Änderungen an Terminen werden beim Abo automatisch synchronisiert.
                    Das ist besonders praktisch, wenn sich Trainings, Briefings oder Rennen verschieben.
                </p>
            </section>

            <section className="rv-modern-card">
                <div className="rv-section-head">
                    <div>
                        <div className="rv-section-kicker">Season Schedule</div>
                        <h2>Race Calendar</h2>
                    </div>

                    <span className="rv-status-pill rv-status-pill--warn">
                        GT3X
                    </span>
                </div>

                <div
                    style={{
                        width: "100%",
                        maxWidth: "980px",
                        margin: "8px auto 0",
                    }}
                >
                    <img
                        src="/schedule/Schedule-GT3X-Season3.png"
                        alt="GT3X Season Schedule"
                        style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                            borderRadius: "18px",
                            border: "1px solid rgba(255,255,255,.10)",
                            boxShadow: "0 18px 38px rgba(0,0,0,.34)",
                        }}
                    />
                </div>
            </section>
        </div>
    );
}